import React from "react";
import bgPersonligTraning from "../../assets/images/bg_kost.png";
import HeaderImage from "../General/HeadImage";
import Footer from "../Footer/Footer";
import NavRoute from "../NavRoute/NavRoute";
import { Helmet } from "react-helmet";
import ptMarcus from "../../assets/images/bg_pt-marcus_bg2.png";
import Welcome from "../General/Welcome";
import gymbild_1 from "../../assets/images/gymet_1.png";
import gymbild_2 from "../../assets/images/gymet_2.png";
import gymbild_3 from "../../assets/images/gymet_3.png";
import gymbild_4 from "../../assets/images/gymet_4.png";
import gymbild_5 from "../../assets/images/gymet_5.png";
import gymbild_6 from "../../assets/images/gymet_6.png";

const photos = [
  {
    src: gymbild_1,
    width: 4,
    height: 3
  },
  {
    src: gymbild_2,
    width: 5,
    height: 4
  },
  {
    src: gymbild_3,
    width: 2,
    height: 3
  },
  {
    src: gymbild_4,
    width: 4,
    height: 3
  },
  {
    src: gymbild_5,
    width: 3,
    height: 3
  },
  {
    src: gymbild_6,
    width: 4,
    height: 3
  }
];

const style = {
  bottomRow: {
    marginBottom: "3em"
  }
};

const KostRadgivning = () => {
  return (
    <div className="page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>PT Marcus, personlig tränare på östermalm</title>
        <meta
          name="description"
          content="Marcus Englund, en personlig tränare i hjärtat på östermalm. Vi hjälper även till med kostrådgivning!"
        />
        <meta
          property="og:title"
          content="PT Marcus din personliga tränare på östermalm, stockholm."
        />
        <meta
          property="og:description"
          content="PT Marcus erbjuder personlig, duo, samt företags träning, i en trygg miljö i centrala östermalm."
        />
        <meta property="og:url" content="https://www.ptmarcus.com" />
        <meta property="og:site_name" content="pt-marcus" />
        <meta property="og:type" content="Website" />
        <meta
          name="keywords"
          content="personlig, pt, stockholm, personlig tränare, östermalm"
        />
        <meta property="og:image" content={ptMarcus} />
      </Helmet>
      <NavRoute />
      <HeaderImage
        bgImage={bgPersonligTraning}
        heading={"Kostrådgivning"}
        subHeading={"God kosthållning och fysisk aktivitet ger snabba resultat"}
      />
      <Welcome
        heading="Masterutbildad dietist"
        text="Då vi samarbetar med en legitimerad dietist, som även har en masterutbildning i idrottsnutrition kan vi erbjuda följande tjänster:  Skräddarsydda kostprogram efter dina mål. Generella råd/tips om kosthållning. Behandlingar av eventuella kostproblem. kostnadseffektiva paketpriser vid köp av PT och kostpaket."
      />

      <Footer />
    </div>
  );
};

export default KostRadgivning;
